import { gql } from '@apollo/client';

export const MUTATION = gql`
  mutation UpdateParticipantGroups($formId: Int!, $participantGroups: [ExistingParticipantGroupInput]!) {
    updateParticipantGroups(input: { form_id: $formId, participant_groups: $participantGroups }) {
      participant_groups {
        id
        name
        form_id
        description
        participant_fee
        from_birthdate_range
        to_birthdate_range
        gender_options
        capacity_limit
        active
        roster_scope_id
        roster_scope_type
        roster_mode
      }
    }
  }
`;
